import { render, staticRenderFns } from "./ApprovalForm.vue?vue&type=template&id=f316a2e4&scoped=true"
import script from "./ApprovalForm.vue?vue&type=script&lang=js"
export * from "./ApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./ApprovalForm.vue?vue&type=style&index=0&id=f316a2e4&prod&scoped=true&lang=css"
import style1 from "./ApprovalForm.vue?vue&type=style&index=1&id=f316a2e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f316a2e4",
  null
  
)

export default component.exports